import React from 'react';
import {
  string, shape, bool, func,
} from 'prop-types';
import { Input, Label, PasswordInput } from '@americanexpress/dls-react';
import Keyboard from 'react-simple-keyboard';
import styles from './styles.scss';

const lowerCaseLayout = 'default';
const upperCaseLayout = 'shift';
const LAYOUT_BUTTONS = "~ ! @ # $ % ^ & * ( ) _ + Q W E R T Y U I O P { } | A S D F G H J K L : \" Z X C V B N M < > ? .com @ ` 1 2 3 4 5 6 7 8 9 0 - = {bksp} {tab} q w e r t y u i o p [ ] \\ {lock} a s d f g h j k l ; ' {enter} {shift} z x c v b n m , . / .com @ {space}";

const PasswordInputWrapper = ({
  type,
  hideMultiPagePassword,
  hidePassword,
  passwordLabel,
  passwordRef,
  defaultValue,
  showVirtualKeyboard,
  onSubmit,
  languageData,
}) => {
  const [keyboardOpen, setKeyboardOpen] = React.useState(false);
  const [passwordValue, setPasswordValue] = React.useState('');
  const [keyboardLayout, setKeyboardLayout] = React.useState(lowerCaseLayout);
  const keyboardRef = React.useRef(null);

  if ((type === 'multipage' && hideMultiPagePassword) || hidePassword) {
    return null;
  }

  const changeKeyboardVisibility = () => setKeyboardOpen(!keyboardOpen);

  const onChangeKeyboard = (input) => {
    setPasswordValue(input);
  };

  const onKeyPressKeyboard = (button) => {
    if (button === '{shift}' || button === '{lock}') {
      setKeyboardLayout(keyboardLayout === lowerCaseLayout ? upperCaseLayout : lowerCaseLayout);
    }

    if (button === '{enter}' && onSubmit) {
      setKeyboardOpen(false);
      onSubmit();
    }
  };

  const onChangePassword = (event) => {
    const input = event.target.value;
    setPasswordValue(input);

    if (showVirtualKeyboard) {
      keyboardRef.current.setInput(input);
    }
  };

  const setKeayboardRef = (el) => {
    keyboardRef.current = el;
  };

  let inputClass = 'eliloPassword';

  if (showVirtualKeyboard) {
    inputClass = ` ${styles.passwordField}`;
  }

  const { show, hide } = languageData;

  return (
    <div className="form-group position-relative">
      <Label id="eliloPassword-label" htmlFor="eliloPassword">{passwordLabel}</Label>
      {showVirtualKeyboard ? (
        <Input
          id="eliloPassword"
          data-testid="keyboard-password-input"
          className={inputClass}
          defaultValue={defaultValue}
          aria-labelledby="eliloPassword-label"
          ref={passwordRef}
          onChange={onChangePassword}
          value={passwordValue}
          autoComplete="current-password"
          reactlytics={{
            element: 'Login_PasswordInput',
          }}
          type="password"
        />
      ) : (
        <PasswordInput
          id="eliloPassword"
          data-testid="password-input"
          className={inputClass}
          defaultValue={defaultValue}
          aria-labelledby="eliloPassword-label"
          ref={passwordRef}
          onChange={onChangePassword}
          value={passwordValue}
          autoComplete="current-password"
          reactlytics={{
            element: 'Login_PasswordInput',
          }}
          showLabel={show}
          hideLabel={hide}
        />
      )}
      {showVirtualKeyboard && (
      <span
        data-testid="keyboard-icon"
        className={`${styles.keyboardIcon} ${keyboardOpen && styles.active}`}
        onClick={changeKeyboardVisibility}
        onKeyPress={changeKeyboardVisibility}
        role="button"
        aria-label={`${keyboardOpen ? 'close' : 'open'} virtual keyboard`}
        tabIndex="0"
      >
        <svg xmlns="http://www.w3.org/2000/svg" height="48" viewBox="0 96 960 960" width="36">
          <path d="M140 856q-24 0-42-18.5T80 796V356q0-24 18-42t42-18h680q24 0 42 18t18 42v440q0 23-18 41.5T820 856H140Zm0-60h680V356H140v440Zm160-65h360v-60H300v60Zm-97-125h60v-60h-60v60Zm124 0h60v-60h-60v60Zm123 0h60v-60h-60v60Zm124 0h60v-60h-60v60Zm123 0h60v-60h-60v60ZM203 481h60v-60h-60v60Zm124 0h60v-60h-60v60Zm123 0h60v-60h-60v60Zm124 0h60v-60h-60v60Zm123 0h60v-60h-60v60ZM140 796V356v440Z" />
        </svg>
      </span>
      )}
      {keyboardOpen && (
        <div className={styles.keyboardContainer} data-testid="keyboard-container">
          <button
            data-testid="close-keyboard-button"
            className={styles.closeBtn}
            type="button"
            onClick={changeKeyboardVisibility}
            aria-label="close virtual keyboard"
          >
            X
          </button>
          <Keyboard
            keyboardRef={setKeayboardRef}
            layoutName={keyboardLayout}
            onChange={onChangeKeyboard}
            onKeyPress={onKeyPressKeyboard}
            buttonAttributes={[
              {
                attribute: 'role',
                value: 'button',
                buttons: LAYOUT_BUTTONS,
              },
              {
                attribute: 'tabindex',
                value: '0',
                buttons: LAYOUT_BUTTONS,
              },
            ]}
          />
        </div>
      )}
    </div>
  );
};

PasswordInputWrapper.propTypes = {
  type: string,
  passwordLabel: string,
  hideMultiPagePassword: bool,
  hidePassword: bool,
  passwordRef: shape({}),
  defaultValue: string,
  showVirtualKeyboard: bool,
  onSubmit: func,
  languageData: shape({}),
};

PasswordInputWrapper.defaultProps = {
  type: undefined,
  showVirtualKeyboard: false,
};

export default PasswordInputWrapper;
